import React from 'react'
import classnames from 'classnames'

import {
  Button,
  BUTTON_THEME,
  BUTTON_SIZE,
  Icon,
  Modal,
} from '@st-operations/uikit/src/v2/index.js'

import { useDropdown, useModal } from '_hooks'

import useFiltersCRUD from '../useFiltersCRUD'
import FilterEditForm from '../filter-edit-form/index.jsx'
import ManageComponent from '../../../manage-component/index.jsx'
import './styles.scss'

const AddFilter = ({ className }) => {
  const { isOpen, handleOpen, handleClose, dropdownRef } = useDropdown()
  const {
    handleSaveChanges,
    handleAddFilter,
    handleEditFilter,
    selectedTabIndex,
    isLoading,
    filters,
  } = useFiltersCRUD({
    onSave: handleClose,
  })
  const audienceFilterConfirmationModal = useModal(false)
  const hasAudienceFilterSelected = filters.some((filter) => filter.key === 'audience')

  const handleAddButtonClick = () => {
    handleAddFilter()
    handleOpen()
  }

  const handleSaveChangesClick = () => {
    if (filters.some((filter) => filter.key === 'audience') && filters.length > 1) {
      audienceFilterConfirmationModal.handleOpenModal()
      return
    }

    handleSaveChanges()
  }

  const handleConfirmChangesClick = () => {
    audienceFilterConfirmationModal.handleCloseModal()
    handleSaveChanges(filters.filter((filter) => filter.key === 'audience'))
  }

  const handleCancelChanges = () => {
    audienceFilterConfirmationModal.handleCloseModal()
    handleClose()
  }

  return (
    <ManageComponent>
      <Modal
        isOpen={audienceFilterConfirmationModal.isOpen}
        classes={{ childWrapper: 'audience-filter-confirmation__wrapper' }}
        onClose={() => {}}
      >
        <div title="Confirm filter change">
          <p className="audience-filter-confirmation__text">
            If you save changes, the audience filter will be applied and all other filters will be
            removed.
          </p>
          <div>
            <Button
              theme={BUTTON_THEME.GHOST}
              className="modal__button"
              onClick={handleCancelChanges}
            >
              Cancel
            </Button>
            <Button className="modal__button" onClick={handleConfirmChangesClick}>
              Confirm
            </Button>
          </div>
        </div>
      </Modal>

      <div className={classnames('add-filter', className)}>
        <div className="add-filter__button-container">
          <Button
            className="add-filter__button"
            onClick={handleAddButtonClick}
            theme={BUTTON_THEME.GHOST}
            disabled={hasAudienceFilterSelected}
          >
            <Icon icon="plus2" type="fill" width={16} height={16} color="currentColor" />
            <span>New Filter</span>
          </Button>
          <If condition={hasAudienceFilterSelected}>
            <p className="add-filter__audience-filter-message">
              You need to delete the audience filter to add new ones.
            </p>
          </If>
        </div>
        <If condition={isOpen}>
          <div ref={dropdownRef} className="add-filter__dialog">
            <FilterEditForm
              key={selectedTabIndex}
              className="add-filter__edit-form"
              id={selectedTabIndex}
              attribute={filters?.[selectedTabIndex]?.key}
              operator={filters?.[selectedTabIndex]?.operator}
              value={filters?.[selectedTabIndex]?.value}
              onEdit={handleEditFilter}
            >
              Dialog
            </FilterEditForm>
            <footer>
              <Button
                className="add-filter__footer-button"
                onClick={handleClose}
                theme={BUTTON_THEME.GHOST}
                size={BUTTON_SIZE.SMALL}
              >
                Cancel
              </Button>
              <Button
                isLoading={isLoading}
                className="add-filter__footer-button"
                onClick={handleSaveChangesClick}
                size={BUTTON_SIZE.SMALL}
              >
                Save
              </Button>
            </footer>
          </div>
        </If>
      </div>
    </ManageComponent>
  )
}

export default AddFilter
